export default __webpack_public_path__ + "static/media/black-2.c3389496.png";